/* istanbul ignore file */
import { UAParser } from 'ua-parser-js';

export function parseUserAgent(userAgent: string): UAParser {
	return new UAParser(userAgent);
}

export type ParsedUserAgent = UAParser;
